// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerNav_block__Izj9_","list":"PlayerNav_list__9pGKw","active":"PlayerNav_active__gQsbp"};